import { c as _c } from "react/compiler-runtime";
import type { Entity, EntityOnboarding } from '@onefootprint/request-types/dashboard';
import type { ComponentProps } from 'react';
import { useDecryptOnboarding, useDecryptOnboardingDocuments } from '@/components/entity-onboarding-details';
import type useEntityVault from '@/entities/hooks/use-entity-vault';
import OnboardingHeader from '../../../onboarding-header';
type OnboardingDataHeaderProps = {
  entity: Entity;
  onboarding: EntityOnboarding;
  vault: ReturnType<typeof useEntityVault>;
  /** What "Decrypt all" can do for the vault. Unset while the attributes load. */
  vaultDecrypt?: {
    isNeeded: boolean;
    canDecrypt: boolean;
  };
};
const OnboardingDataHeader = t0 => {
  const $ = _c(16);
  const {
    entity,
    onboarding,
    vault,
    vaultDecrypt
  } = t0;
  let t1;
  if ($[0] !== entity || $[1] !== onboarding || $[2] !== vault.data || $[3] !== vault.isDecryptable || $[4] !== vault.update) {
    t1 = {
      entity,
      onboarding,
      onDecryptSuccess: vault.update,
      vaultData: vault.data,
      isDecryptable: vault.isDecryptable
    };
    $[0] = entity;
    $[1] = onboarding;
    $[2] = vault.data;
    $[3] = vault.isDecryptable;
    $[4] = vault.update;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    decrypt: decryptVault,
    isDecrypting: isVaultDecrypting
  } = useDecryptOnboarding(t1);
  const documentsDecrypt = useDecryptOnboardingDocuments(entity, onboarding);
  let t2;
  if ($[6] !== decryptVault || $[7] !== documentsDecrypt || $[8] !== isVaultDecrypting || $[9] !== vaultDecrypt) {
    t2 = () => {
      if (!vaultDecrypt || documentsDecrypt.isPending) {
        return "pending";
      }
      if (!vaultDecrypt.isNeeded && !documentsDecrypt.hasEncryptedDocuments) {
        return;
      }
      const canDecryptDocuments = documentsDecrypt.hasEncryptedDocuments && documentsDecrypt.canDecrypt;
      return {
        canDecrypt: vaultDecrypt.canDecrypt || canDecryptDocuments,
        isDecrypting: isVaultDecrypting || documentsDecrypt.isDecrypting,
        onDecrypt: async () => {
          await Promise.all([vaultDecrypt.canDecrypt && decryptVault(), canDecryptDocuments && documentsDecrypt.decrypt()]);
        }
      };
    };
    $[6] = decryptVault;
    $[7] = documentsDecrypt;
    $[8] = isVaultDecrypting;
    $[9] = vaultDecrypt;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const getDecrypt = t2;
  let t3;
  if ($[11] !== getDecrypt) {
    t3 = getDecrypt();
    $[11] = getDecrypt;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== onboarding || $[14] !== t3) {
    t4 = <OnboardingHeader onboarding={onboarding} decrypt={t3} />;
    $[13] = onboarding;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export default OnboardingDataHeader;